import React from 'react'
import PropTypes from 'prop-types'
import { Redirect, Route } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useRefreshTokenQuery } from 'api/User/Users/queries'
import useNotification from 'hooks/useNotification'
import parseError from 'helpers/errorHelpers'

import { isAuthenticatedSelector, userRoleSelector } from 'store/auth/selectors'

// const SentryRoute = Sentry.withSentryRouting(Route)

function AuthenticatedRoute({ children, access, restrict, allow, ...rest }) {
  const isAuthenticated = useSelector(isAuthenticatedSelector)

  const { addNotification } = useNotification()

  const userRole = useSelector(userRoleSelector)

  useRefreshTokenQuery({
    queryOptions: {
      enabled: location.pathname === '/refresh',
      onError: (error) => {
        addNotification({
          type: 'error',
          message: parseError(error, `Error refreshing token`),
        })
      },
    },
  })

  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (location.pathname === '/refresh') {
          return (
            <Redirect
              to={{ pathname: '/dashboard', state: { from: location } }}
            />
          )
        } else if (!isAuthenticated) {
          return <Redirect to={{ pathname: '/', state: { from: location } }} />
        } else if (
          (access &&
            !access.includes(userRole) &&
            allow &&
            !allow.includes(userRole)) ||
          (restrict && restrict.includes(userRole))
        ) {
          return (
            <Redirect
              to={{ pathname: '/dashboard', state: { from: location } }}
            />
          )
        } else {
          return children
        }
      }}
    />
  )
}

export default AuthenticatedRoute

AuthenticatedRoute.propTypes = {
  children: PropTypes.node,
  restrict: PropTypes.array,
  access: PropTypes.array,
  allow: PropTypes.array,
}
